(ns common.schema.entities.sales-opportunity.schema
  (:require
   [common.schema.constraints :as constraints]
   [common.schema.entities.common :as common-schema]
   [common.schema.option-filters :as option-filters]
   [common.schema.schema-utils :as su]
   [common.status :as statuses]))

(def import-fixed-fields
  [:sales-opportunity/name
   :sales-opportunity/customer
   :sales-opportunity/pipeline
   :sales-opportunity/stage
   :sales-opportunity/status])

(def schema
  (vec
   (concat
    (su/text-simple-field
     :sales-opportunity/name
     "Name"
     {:name-attribute           :sales-opportunity/name
      :lower-case-str?          true
      :not-clearable?           true
      :mandatory-config         :mandatory/always
      :system-semantics         su/user-provided-system-required-field-semantics
      :system-required?         true
      :editor-type              :editor.type/none
      :default-field-visibility :in-use-disabled
      :constraints              {:constraint/string-min-length         1
                                 :constraint/unique-tenant-ignore-case
                                 {:validation-fn (partial constraints/tenant-unique-ignore-case
                                                          :sales-opportunity/name
                                                          [:entity.type/sales-opportunity])}}})
    (su/text-multiline-field :sales-opportunity/description
                             "Description"
                             {:create-visibility        :create.visibility/optional
                              :default-field-visibility :in-use})
    (su/single-ref-field :sales-opportunity/pipeline
                         "Pipeline"
                         [:entity.type/pipeline]
                         {:not-clearable?           true
                          :option-filter-fn         (partial option-filters/pipelines
                                                             :entity.type/sales-opportunity)
                          :mandatory-config         :mandatory/always
                          :system-semantics         su/user-provided-system-required-field-semantics
                          :system-required?         true
                          :field-in-use-filter      su/pipeline-in-use?
                          :default-field-visibility :in-use-disabled
                          :authorization            {:access/read :role/guest-buy-side}})
    (su/single-ref-field :sales-opportunity/customer
                         "Customer"
                         ;;note: will be either investor OR person/company based on
                         ;; corresponding :pipeline/target-asset-types
                         [:entity.type/investor
                          :entity.type/company
                          :entity.type/person]
                         {:create-on-fly?           true
                          :deep-indexing?           true
                          :select-entity-types      [:entity.type/person :entity.type/company]
                          :create-entity-types      [:entity.type/person :entity.type/company]
                          :editor-type              :editor.type/none
                          :grid-type                :editor.type/link
                          :filter                   :filter.type/select
                          :default-field-visibility :in-use-disabled})
    (su/single-ref-field :sales-opportunity/owner
                         "Owner"
                         [:entity.type/account]
                         {:option-filter-fn         option-filters/active-users
                          :os-filter-terms-fn       (fn [{:keys [] :as _args}]
                                                      {"extras.active-user" true})
                          :system-semantics         su/system-prefilled-required-field-semantics
                          :system-required?         true
                          :not-clearable?           true
                          :default-field-visibility :in-use-disabled})
    (su/single-ref-field :sales-opportunity/credit
                         "Credit"
                         [:entity.type/account]
                         {:option-filter-fn         option-filters/active-users
                          :os-filter-terms-fn       (fn [{:keys [] :as _args}]
                                                      {"extras.active-user" true})
                          :create-visibility        :create.visibility/optional
                          :default-field-visibility :in-use})
    (su/percentage-field :sales-opportunity/probability-percentage
                         "Probability %"
                         {:create-visibility        :create.visibility/optional
                          :default-field-visibility :not-in-use})
    (su/option-field :sales-opportunity/lead-source
                     "Lead source"
                     {:default-field-visibility :in-use})
    (su/option-field :sales-opportunity/probability-category
                     "Probability"
                     {:default-field-visibility :in-use})
    (su/currency-field :sales-opportunity/cur-estimated-ARR
                       "Estimated yearly revenue (ARR)"
                       {:create-visibility        :create.visibility/optional
                        :default-field-visibility :in-use})
    (su/currency-field :sales-opportunity/cur-offered-price
                       "Offered price"
                       {:create-visibility        :create.visibility/optional
                        :default-field-visibility :not-in-use})
    (su/text-multiline-field :sales-opportunity/next-steps
                             "Next steps"
                             {:create-visibility        :create.visibility/optional
                              :default-field-visibility :in-use})
    (su/text-multiline-field :sales-opportunity/overview
                             "Overview"
                             {:create-visibility        :create.visibility/optional
                              :default-field-visibility :in-use-disabled})
    (su/datetime-field :sales-opportunity/offer-sent-on
                       "Offer sent on"
                       {:editor-type       :editor.type/date
                        :grid-type         :editor.type/date
                        :filter-type       :filter.type/date
                        :default-field-visibility :not-in-use
                        :create-visibility :create.visibility/optional})

    [[:sales-opportunity/status
      {:field/data-type :data.type/keyword
       :value-type :keyword
       :field/mandatory :mandatory/always
       :field/system-semantics su/user-provided-system-required-field-semantics
       :field/system-required? true
       :field/default-visibility {:editor :editor.type/none
                                  :grid   :editor.type/select
                                  :filter :filter.type/select
                                  :field-visibility :in-use-disabled}
       :field/default-authorization {:access/read  :role/user
                                     :access/write :role/user}
       :field/not-clearable? true
       :field/not-shown-in-create? true
       :field/translations {:en "Status"}
       :options statuses/sales-opportunity-status-options}]
     common-schema/team-members-field
     common-schema/common-network-drive-field]
    common-schema/common-network-drives-field
    common-schema/common-folders-path

    (su/datetime-field :sales-opportunity/on-hold-until
                       "On hold until"
                       {:editor-type       :editor.type/none
                        :grid-type         :editor.type/date
                        :filter-type       :filter.type/date
                        :default-field-visibility :in-use-disabled
                        :create-visibility :create.visibility/optional
                        :system-semantics  su/system-controlled-optional-field-semantics})
    (su/datetime-field :sales-opportunity/won-on
                       "Won on"
                       {:editor-type       :editor.type/none
                        :grid-type         :editor.type/date
                        :filter-type       :filter.type/date
                        :default-field-visibility :in-use-disabled
                        :create-visibility :create.visibility/optional
                        :system-semantics  su/system-controlled-optional-field-semantics})
    (su/datetime-field :sales-opportunity/lost-on
                       "Lost on"
                       {:editor-type       :editor.type/none
                        :grid-type         :editor.type/date
                        :filter-type       :filter.type/date
                        :default-field-visibility :in-use-disabled
                        :create-visibility :create.visibility/optional
                        :system-semantics  su/system-controlled-optional-field-semantics})
    (su/datetime-field :sales-opportunity/put-on-hold-on
                       "Put on hold on"
                       {:editor-type       :editor.type/none
                        :grid-type         :editor.type/date
                        :filter-type       :filter.type/date
                        :default-field-visibility :in-use-disabled
                        :create-visibility :create.visibility/optional
                        :system-semantics  su/system-controlled-optional-field-semantics})
    (su/text-multiline-field :sales-opportunity/on-hold-comment
                             "Last on hold comment"
                             {:create-visibility :create.visibility/optional
                              :default-field-visibility :in-use-disabled
                              :editor-type       :editor.type/none
                              :system-semantics  su/system-controlled-optional-field-semantics})
    (su/option-field :sales-opportunity/lost-reason
                     "Lost reason"
                     {:default-field-visibility :in-use-disabled
                      :create-visibility :create.visibility/optional
                      :editor-type :editor.type/none
                      :grid :editor.type/select
                      :system-semantics su/system-controlled-optional-field-semantics})
    (su/option-field-multi :sales-opportunity/offered-services
                           "Offered services"
                           {:default-field-visibility :not-in-use
                            :create-visibility        :create.visibility/optional})
    (su/single-ref-field :sales-opportunity/offered-asset
                         "Offered asset"
                         [:entity.type/holding]
                         {:default-field-visibility :not-in-use
                          :create-visibility        :create.visibility/optional})
    (su/text-multiline-field :sales-opportunity/lost-comment
                             "Lost comment"
                             {:create-visibility :create.visibility/optional
                              :default-field-visibility :in-use-disabled
                              :editor-type       :editor.type/none})
    (su/single-ref-field :sales-opportunity/stage
                         "Stage"
                         [:entity.type/sales-opportunity-stage]
                         {:mandatory-config         :mandatory/always
                          :system-semantics         su/user-provided-system-required-field-semantics
                          :system-required?         true
                          :not-clearable?           true
                          :option-filter-fn         option-filters/sales-opportunity-stages-in-pipeline
                          :field-in-use-filter      su/pipeline-in-use?
                          :default-field-visibility :in-use-disabled})
    (su/datetime-field :sales-opportunity/datetime-expected-decision
                       "Expected decision"
                       {:create-visibility :create.visibility/optional
                        :editor-type       :editor.type/datetime
                        :grid-type         :editor.type/datetime
                        :filter-type       :filter.type/date
                        :default-field-visibility :in-use})
    (su/option-field-multi :sales-opportunity/tag-tags
                           "Tags"
                           {:create-visibility        :create.visibility/optional
                            :default-field-visibility :in-use})
    (su/single-ref-field :sales-opportunity/agreement
                         "Agreement"
                         [:entity.type/sale-agreement]
                         {:editor-type          :editor.type/link
                          :default-field-visibility :in-use
                          :not-shown-in-create? true
                          :authorization        su/access-user-user})
    (su/integer-field :sales-opportunity/priority
                      "Priority"
                      {:default-field-visibility :not-in-use})
    (su/text-edn-field :sales-opportunity/ratings
                       "Ratings"
                       {:authorization su/access-user-user
                        :default-field-visibility :in-use})

    (su/datetime-field :sales-opportunity/reactivated-on
                       "Reactivated on"
                       {:default-visibility :in-use-disabled
                        :editor-type        :editor.type/none
                        :system-semantics   su/system-controlled-optional-field-semantics
                        :authorization      su/access-system-user})
    (su/single-ref-field :sales-opportunity/reactivated-by
                         "Reactivated by"
                         [:entity.type/account]
                         {:default-visibility :in-use-disabled
                          :system-semantics   su/system-controlled-optional-field-semantics
                          :authorization      su/access-system-user}))))
